// ========================= CMS =============================
export const CMS_URL = process.env.VUE_APP_CMS_URL || 'http://localhost:1337';
export const API_KEY = process.env.VUE_APP_API_KEY;
export const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:5001'
